import {
    Box,
    Flex,
    IconButton,
    Collapse,
    useColorModeValue,
    useDisclosure,
    Image,
} from '@chakra-ui/react'
import {
    HamburgerIcon,
    CloseIcon,
} from '@chakra-ui/icons'
import DesktopNavBar from './Desktop/DesktopNavBar';
import MobileNavBar from './Mobile/MobileNavBar';
import styles from "../NavBar.module.scss"
import { NavProps_t } from '../NavBarTypes/NavItem';


function ResponsiveNavBar({ navItems, logoUrl }: NavProps_t) {
    const { isOpen, onToggle } = useDisclosure()
    return (
        <Box className={styles['responsive__nav-bar__container']} zIndex={10000} position="relative">
            <Flex className={styles['responsive__nav-bar__flex-container']}
                minH={'5rem'}
                h='10vh'
                py={{ base: 2 }}
                px={{ base: 10 }}
                borderColor={useColorModeValue('gray.200', 'gray.900')}
                align={'center'}
                overflow={{ sm: "scroll", lg: "hidden" }}
                sx={{
                    '&::-webkit-scrollbar': {
                        width: '0.1px',
                    }
                }}>

                <Flex className={styles['nav-bar__base-flex']}
                    flex={{ base: 1 }} align={"center"} justifyContent={'space-between'} >

                    <Box className={styles['nav-bar__logo-container']}
                        cursor={"pointer"} as="a" href='/' minW={"5rem"}>
                        <Image
                            src={logoUrl} h="3rem" w="3rem" borderRadius="full"
                            sx={{
                                '@media (min-width: 768px)': {
                                    h: '4rem',
                                    w: '4rem'
                                }
                            }} />
                    </Box>
                    <Flex className={styles['desktop__nav-bar__flex-container']}
                        display={{ base: 'none', md: 'flex' }} m={0}>
                        <DesktopNavBar navItems={navItems} />
                    </Flex>
                </Flex>


                <Flex
                    display={{ base: 'flex', md: 'none' }}
                    flex={{ base: 1, md: 'auto' }}
                    ml={{ base: -2 }}

                    justify={{ base: 'right' }}>
                    <IconButton
                        _hover={{
                            backgroundColor: "black",
                        }}
                        onClick={onToggle}
                        icon={isOpen ? <CloseIcon w={3} h={3} color={"white"}
                        /> : <HamburgerIcon
                            w={5} h={5} color={"white"}
                        />}
                        variant={'ghost'}
                        aria-label={'Toggle Navigation'}
                    />
                </Flex>


            </Flex>

            <Collapse in={isOpen} animateOpacity style={{ zIndex: 9999, position: 'relative' }}>
                <MobileNavBar navItems={navItems} />
            </Collapse>
        </Box>
    )
}

export default ResponsiveNavBar;